import {
  type ContractDataType,
  type ContractType,
  type ProductOfDayDataType,
} from '../types/contract';

import { entriesToSingleFieldObjArray } from './array';

type GetContractByIdArgs = {
  commonContracts: ContractDataType[] | null;
  productContracts: ProductOfDayDataType[] | null;
  contractId: string;
};

const getContractById = ({
  commonContracts,
  productContracts,
  contractId,
}: GetContractByIdArgs): ContractDataType | ProductOfDayDataType | null => {
  const findFn = ({ id }: ContractDataType | ProductOfDayDataType): boolean =>
    contractId === id;

  const commonContract = commonContracts?.find(findFn);
  const productContract = productContracts?.find(findFn);

  return commonContract || productContract || null;
};

const getCloseContractAnaliticData = (
  contract: ContractDataType | ProductOfDayDataType | null,
): {
  subtype: ContractType | 'productOfDay';
  reward?: Array<{ [field: string]: unknown }>;
} | null => {
  if (!contract) {
    return null;
  }

  if ('data' in contract) {
    return {
      subtype: contract.type,
      reward: Object.entries({
        ...contract.data,
        dice: contract.dice,
        cash: contract.cash,
        point: contract.point,
      }).map(entriesToSingleFieldObjArray),
    };
  } else {
    return {
      subtype: 'productOfDay',
    };
  }
};

const getContractCommonType = (
  subtype: ContractType | 'productOfDay',
): 'standart' | 'daily' | 'special' => {
  if (subtype === 'productOfDay') {
    return 'daily';
  } else {
    return subtype === 'Default' ? 'standart' : 'special';
  }
};

export { getCloseContractAnaliticData, getContractById, getContractCommonType };
